export const __DEV__ = process.env.NODE_ENV !== 'production';

// is set in production and with serveless-offline plugin
export const IN_LAMBDA = !!(process.env.LAMBDA_TASK_ROOT || process.env.AWS_EXECUTION_ENV);

// is set when using serverless invoke local
export const IS_SLS_LOCAL = (process.env.IS_LOCAL || 'false') === 'true';

// is set when using serveless-offline plugin
export const IS_SLS_OFFLINE = (process.env.IS_OFFLINE || 'false') === 'true';

export const IS_PRODUCTION_LAMBDA = IN_LAMBDA && !IS_SLS_LOCAL && !IS_SLS_OFFLINE;

const AWS_DYNAMO_REGION_PATTERN = /^https:\/\/dynamodb\.((us(-gov)?|ap|ca|cn|eu|sa)-(central|(north|south)?(east|west)?)-\d).amazonaws\.com$/;

export function isInCloudEnvironment(endpoint?: string): boolean {
  if (!endpoint) {
    return true;
  }
  return AWS_DYNAMO_REGION_PATTERN.test(endpoint);
}
